export default "__VITE_ASSET__BAvR5VMH__"